import { ComponentPropsWithoutRef } from 'react';
import { useField } from 'react-final-form';
import { RadioButton } from '../RadioButton';

const updateFieldValue = (fieldValue: any, value: any) => {
  if (!value) return fieldValue;
  if (!fieldValue) return [value];
  if (fieldValue.includes(value)) return fieldValue.filter((v: any) => v !== value);
  return [...fieldValue, value];
};

const MultiselectField = ({
  name,
  value,
  label,
  ...rest
}: {
  name: string;
  value: any;
  label: string;
  [x: string]: any;
}) => {
  const field = useField(name);
  return (
    <RadioButton
      onClick={() => field.input.onChange(updateFieldValue(field.input.value, value))}
      isActive={field.input.value.includes(value)}
      {...rest}
    >
      {label}
    </RadioButton>
  );
};

export default MultiselectField;
